import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { s as e } from "../UnbundlingFareInfographic.module-CzY5rohw.js";
import { c as t } from "../clsx-OuTLNxxd.js";
import o from "react-loading-skeleton";
const u = () => /* @__PURE__ */r("div", {
    className: e.container,
    children: /* @__PURE__ */i("ul", {
      className: e.groups,
      children: [/* @__PURE__ */r(s, {
        id: "cruise",
        rows: 2
      }), /* @__PURE__ */r(s, {
        id: "shorex",
        rows: 1
      }), /* @__PURE__ */r(s, {
        id: "cancellation-policy",
        rows: 1
      })]
    })
  }),
  s = _ref => {
    let {
      id: c,
      rows: n
    } = _ref;
    return /* @__PURE__ */i("li", {
      className: t(e.group),
      children: [/* @__PURE__ */r("div", {
        className: e.groupHeaderIcon,
        children: /* @__PURE__ */r(o, {
          count: 1,
          height: 48,
          width: 48,
          circle: !0
        })
      }), /* @__PURE__ */i("div", {
        className: e.stepsGroupContent,
        children: [/* @__PURE__ */r("div", {
          className: e.groupHeader,
          children: /* @__PURE__ */r(o, {
            count: 1,
            width: "80%"
          })
        }), /* @__PURE__ */r("ul", {
          className: e.steps,
          children: Array.from({
            length: n
          }).map((a, l) => /* @__PURE__ */r("li", {
            children: /* @__PURE__ */r(o, {
              count: 1,
              width: "70%",
              height: "8px"
            })
          }, l))
        })]
      })]
    }, c);
  };
export { u as UnbundlingFareInfographicSkeleton };